const CHUNK_RELOAD_SESSION_KEY = 'reach-chunk-reload-once';

export function isChunkLoadFailureMessage(message: string): boolean {
  const lower = message.toLowerCase();
  if (lower.includes('chunkloaderror')) {
    return true;
  }
  if (lower.includes('loading chunk') && lower.includes('failed')) {
    return true;
  }
  if (lower.includes('failed to load chunk') && lower.includes('/_next/static/chunks/')) {
    return true;
  }
  return false;
}

export function isStaleServerActionMessage(message: string): boolean {
  const lower = message.toLowerCase();
  return (
    lower.includes('unrecognizedactionerror') ||
    (lower.includes('server action') && lower.includes('was not found on the server'))
  );
}

export function shouldReloadForStaleDeployError(message: string, alreadyReloaded: boolean): boolean {
  return (isChunkLoadFailureMessage(message) || isStaleServerActionMessage(message)) && !alreadyReloaded;
}

export function shouldReloadForChunkLoadFailure(message: string, alreadyReloaded: boolean): boolean {
  return shouldReloadForStaleDeployError(message, alreadyReloaded);
}

export function getChunkReloadSessionKey(): string {
  return CHUNK_RELOAD_SESSION_KEY;
}
